import { render, staticRenderFns } from "./documentos.vue?vue&type=template&id=0a5b58f6&scoped=true"
import script from "./documentos.vue?vue&type=script&lang=js"
export * from "./documentos.vue?vue&type=script&lang=js"
import style0 from "./documentos.vue?vue&type=style&index=0&id=0a5b58f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5b58f6",
  null
  
)

export default component.exports